import { Injectable } from '@angular/core';
import { Router, Route, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad } from '@angular/router';
import { AuthService } from './auth.service';
import { UserService } from './api/user.service';
import { AppService } from './api/app.service';
import { ConfigService } from '../config.service';

@Injectable()
export class AuthorizedGuard implements CanActivate, CanLoad {
    constructor(private _authService: AuthService, private _appService: AppService, private _userService: UserService, private router: Router) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.checkLogin(route.url[0].path);
    }

    public canLoad(route: Route): Promise<boolean> {
        return this.checkLogin(route.path);
    }

    checkLogin(path: string): Promise<boolean> {
        const defaultRedirect =  '/marketplace';
        return this._authService.isAuthenticated().then( user => {
            if (!user) {
                if (ConfigService.app.oauthExternal) {
                    this.router.navigate(['/loginExternal']);
                } else {
                    this.router.navigate(['/login']);
                }
                return user;
            } else {
                return this._userService.getCurrent().toPromise().then(currentUser => {
                    return this._appService.getAccessibleAppPermissionGroupIdsByPath(path).toPromise().then
                    (
                        app => {
                            // if there is no or there are multiple apps returned then reject access
                            if (!app) {
                                this.router.navigate([defaultRedirect]);
                                return false;
                            }
                            // finding out if app.permissionGroupIds and currentUser.permissionGroupIds have any intersection
                            const isAuthorized = app.permissionGroupIds.filter(e => currentUser.permissionGroupIds.indexOf(e) !== -1).length > 0;
                            if (!isAuthorized) {
                                this.router.navigate([defaultRedirect]);
                            }
                            return isAuthorized;
                        }
                    )
                });
            }
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/core/authorized.guard.ts